module.exports = __webpack_public_path__ + "static/media/ruby.99b1a10e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/stacks/images/icons/ruby.png
// module id = 572
// module chunks = 0